import editableEnhancer from 'app/general/editableEnhancer';

import {EditKBMetadata} from './EditKBMetadata';
import {ViewKBMetadata} from './ViewKBMetadata';

export const EditableKBMetadata = editableEnhancer(
  ViewKBMetadata,
  EditKBMetadata
);
